import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-16 px-6 md:px-8 max-w-3xl mx-auto text-center" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-49">
        <span className="inline-block bg-forest/10 text-forest px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-6" data-id="element-50">
          Edición Cero Sobregiros
        </span>

        <h1 className="text-4xl md:text-6xl font-serif text-charcoal leading-tight mb-4" data-id="element-51">
          ¿Cuánto puedo gastar sin miedo?
        </h1>

        <p className="text-xl md:text-2xl text-warm-gray mb-10 font-medium" data-id="element-52">
          10 minutos el día de pago. Paz toda la semana.
        </p>

        <div className="mb-8 relative group" data-id="element-53">
          <div className="absolute inset-0 bg-forest/5 rounded-2xl transform rotate-1 scale-105 -z-10" data-id="element-54" />
          <img src="https://cdn.magicpatterns.com/uploads/sdw8b7nTa83YBWNj2KEqgU/3E17E5E6-0326-42C7-A3AD-C168CE223211.png" alt="El Mapa de Pago en 10 Min en tablet" className="rounded-xl shadow-xl w-full max-w-lg mx-auto border border-warm-gray/10" data-id="element-55" />
        </div>

        <p className="text-warm-gray italic text-sm md:text-base max-w-md mx-auto mb-12 leading-relaxed" data-id="element-56">
          Tu sistema de 1 página para pagar lo que toca, proteger lo esencial y
          saber qué sí puedes gastar esta semana—sin registrar cada compra.
        </p>

        <div className="text-left max-w-xl mx-auto space-y-6 text-lg md:text-xl leading-relaxed text-charcoal/90" data-id="element-57">
          <p data-id="element-58">Hay un tipo de cansancio que no es por trabajar…</p>
          <p className="font-semibold" data-id="element-59">Es por adivinar.</p>
          <p data-id="element-60">Adivinar si ese gasto "pasa".</p>
          <p data-id="element-61">Adivinar si el autopay va a caer antes o después.</p>
          <p data-id="element-62">Adivinar si te va a pegar un sobregiro por una compra pequeña.</p>
          <p data-id="element-63">Y lo peor no es el número.</p>
          <p data-id="element-64">
            Es el momento en que abres la app del banco y sientes ese golpe en
            el pecho.
          </p>
          <p className="pt-4" data-id="element-65">Este PDF existe para una sola cosa:</p>
          <p data-id="element-66">
            que el día de pago, en{' '}
            <span className="font-bold text-forest" data-id="element-67">10 minutos</span>, tengas
            una respuesta clara:
          </p>
          <p className="font-serif text-2xl text-forest italic" data-id="element-68">
            "Esto es lo que puedo gastar esta semana sin miedo."
          </p>
        </div>

        <div className="mt-12" data-id="element-69">
          <Button scrollTo="checkout" data-id="element-70">Descarga tu Mapa de Pago — $6.36</Button>
          <p className="mt-4 text-sm text-warm-gray" data-id="element-71">
            Pago único · Descarga inmediata · Menos que un café con leche
          </p>
        </div>
      </motion.div>
    </section>;
}